import { Locale } from "./i18n";

export default {
    display: "Français",
    code: "fr",
    translation: {
        "arc.angle": "Angle",
        "arc.start": "Début",
        "axis.x": "Axe X",
        "axis.y": "Axe Y",
        "axis.z": "Axe Z",
        "body.arc": "Arc",
        "body.bolean": "Booléen",
        "body.box": "Boîte",
        "body.circle": "Cercle",
        "body.face": "Face",
        "body.fuse": "Fusion",
        "body.imported": "Importé",

        "body.line": "Ligne",
        "body.polygon": "Polygone",
        "body.prism": "Prisme",
        "body.rect": "Rectangle",
        "body.revol": "Révolution",
        "body.sweep": "Balayage",
        "body.wire": "Fil",
        "box.dx": "Longueur",
        "box.dy": "Largeur",
        "box.dz": "Hauteur",
        "body.editableShape": "Forme Éditable",
        "body.meshNode": "Nœud de Maillage",
        "body.multiShape": "Forme Multiple",
        "circle.center": "Centre",
        "circle.radius": "Rayon",
        "command.arc": "Arc",
        "command.array": "Tableau",
        "command.bezier": "Bézier",
        "command.boolean.common": "Commun",
        "command.boolean.cut": "Couper",
        "command.boolean.fuse": "Fusionner",
        "command.box": "Boîte",
        "command.break": "Casser",
        "command.circle": "Cercle",
        "command.copy": "Copier",
        "command.delete": "Supprimer",
        "command.document.new": "Nouveau Dessin",
        "command.document.open": "Importer Dessin",
        "command.document.save": "Enregistrer",
        "command.document.saveAs": "Enregistrer Sous",
        "command.document.saveToFile": "Enregistrer dans un Fichier",
        "command.export": "Exporter",
        "command.faceable.isFace": "Face",
        "command.fuse": "Fusionner",
        "command.import": "Importer",
        "command.line.isConnected": "Connecté",
        "command.line": "Ligne",
        "command.mirror": "Miroir",
        "command.mode.repeat": "Répéter",
        "command.move": "Déplacer",
        "command.newFolder": "Nouveau Dossier",
        "command.newGroup": "Nouveau Groupe",
        "command.offset": "Décalage",
        "command.polygon": "Polygone",
        "command.prism": "Prisme",
        "command.rect": "Rectangle",
        "command.redo": "Rétablir",
        "command.revol": "Révolution",
        "command.rotate": "Rotation",
        "command.section": "Section",
        "command.split": "Diviser",
        "command.sweep": "Balayage",
        "command.thickSolid": "Solide Épais",
        "command.toFace": "Vers Face",
        "command.toWire": "Vers Fil",
        "command.trim": "Ajuster",
        "command.undo": "Annuler",
        "common.angle": "Angle",
        "common.back": "Retour",
        "common.cancel": "Annuler",
        "common.clone": "Cloner",
        "common.color": "Couleur",
        "common.confirm": "Confirmer",
        "common.general": "Général",
        "common.length": "Longueur",
        "common.material": "Matériau",
        "common.matrix": "Matrice",
        "common.name": "Nom",
        "common.normal": "Normal",
        "common.opacity": "Opacité",
        "common.thickness": "Épaisseur",
        "common.type": "Type",
        "entity.editable": "Entité Éditable",
        "entity.parameter": "Entité Paramétrique",
        "error.default:{0}": "erreur: {0}",
        "error.input.cannotInputANumber":
            "Chevauchement avec le point de référence, impossible de saisir 1 nombre",
        "error.input.invalidNumber": "Veuillez entrer un nombre valide, séparé par ,",
        "error.input.threeNumberCanBeInput": "Point de référence vide, seuls 3 nombres peuvent être saisis",
        "error.input.unsupportedInputs": "Dépasse le nombre maximum d'entrées",
        "error.import.unsupportedFileType:{0}": "Type de fichier non pris en charge: {0}",
        "error.export.noNodeCanBeExported": "Aucun nœud ne peut être exporté",
        "file.format": "Format",
        "home.recent": "Récent",
        "home.welcome": "Bienvenue sur LuminiCAD",
        "items.header": "Éléments",
        "items.tool.delete": "Supprimer",
        "items.tool.expandAll": "Tout Développer",
        "items.tool.newFolder": "Nouveau Dossier",
        "items.tool.unexpandAll": "Tout Réduire",
        "line.end": "Fin",
        "line.start": "Début",
        "line.type.line": "Ligne",
        "line.type.xline": "Ligne X",
        "material.texture.image": "Image",
        "material.texture.rotation": "Rotation",
        "material.texture.wrapS": "Enveloppe S",
        "material.texture.wrapT": "Enveloppe T",
        "material.texture.repeat": "Répétition",
        "material.texture.offset": "Décalage",
        "material.map": "Carte",
        "material.specular": "Spéculaire",
        "material.shininess": "Brillance",
        "material.emissive": "Émissif",
        "material.specularMap": "Carte Spéculaire",
        "material.normalMap": "Carte Normale",
        "material.bumpMap": "Carte de Relief",
        "material.roughnessMap": "Carte de Rugosité",
        "material.emissiveMap": "Carte Émissive",
        "material.metalness": "Métallique",
        "material.metalnessMap": "Carte Métallique",
        "material.roughness": "Rugosité",
        "model.visible": "Visible",
        "operate.pickCircleCenter": "sélectionner le centre, touche ÉCHAP pour annuler",
        "operate.pickFistPoint": "Sélectionner le premier point, touche ÉCHAP pour annuler",
        "operate.pickNextPoint": "sélectionner le point suivant, touche ÉCHAP pour annuler",
        "operate.pickRadius": "saisir le rayon, touche ÉCHAP pour annuler",
        "polygon.points": "Points",
        "prompt.default":
            "Bouton central de la souris pour déplacer la vue, Maj + bouton central pour faire pivoter la vue, bouton central pour zoomer",
        "prompt.deleteDocument{0}": "Voulez-vous supprimer {0} ?",
        "prompt.polygon.close": "Fermer",
        "prompt.saveDocument{0}": "Voulez-vous enregistrer les modifications de {0} ?",
        "prompt.select.edges": "Veuillez sélectionner les arêtes",
        "prompt.select.faces": "Veuillez sélectionner les faces",
        "prompt.select.models": "Veuillez sélectionner les modèles",
        "prompt.select.noModelSelected": "Aucun modèle sélectionné",
        "prompt.select.shape": "Veuillez sélectionner la forme",
        "prompt.select.vertexs": "Veuillez sélectionner les sommets",
        "prompt.select.wires": "Veuillez sélectionner les fils",
        "properties.group.transform": "Transformation",
        "properties.header": "Propriétés",
        "properties.multivalue": "Valeur Multiple",
        "rect.dx": "Longueur",
        "rect.dy": "Largeur",
        "ribbon.group.boolean": "Booléen",
        "ribbon.group.converter": "Convertisseur",
        "ribbon.group.draw": "Dessin",
        "ribbon.group.importExport": "Import/Export",
        "ribbon.group.modify": "Modifier",
        "ribbon.group.selection": "Sélection",
        "ribbon.group.tools": "Outils",
        "ribbon.group.workingPlane": "Plan de Travail",
        "ribbon.tab.draw": "Dessin",
        "ribbon.tab.file": "Fichier",
        "ribbon.tab.startup": "Éditeur",
        "snap.center": "Centre",
        "snap.end": "Extrémité",
        "snap.intersection": "Intersection",
        "snap.mid": "Milieu",
        "snap.perpendicular": "Perpendiculaire",
        "snap.nearest": "Plus Proche",
        "toast.command.{0}excuting": "Commande {0} en cours d'exécution",
        "toast.converter.error": "Erreur de conversion",
        "toast.converter.invalidColor": "La couleur est invalide",
        "toast.delete{0}Objects": "{0} objets supprimés",
        "toast.document.noActived": "Aucun document actif",
        "toast.document.saved": "Document enregistré",
        "toast.downloading": "Téléchargement en cours",
        "toast.excuting{0}": "Exécution de {0}",
        "toast.fail": "Échec",
        "toast.read.error": "Erreur de lecture",
        "toast.select.noSelected": "Aucune sélection",
        "toast.success": "Succès",
        "transform.rotation": "Rotation",
        "transform.scale": "Échelle",
        "transform.translation": "Translation",
        "vertex.point": "Point",
        "workingPlane.alignToPlane": "Aligner au plan",
        "workingPlane.set": "Définir le plan de travail",
        "test.performace": "Test de performance",
        "chat.title": "Assistant IA",
        "chat.placeholder": "Tapez votre requête CAO...",
        "command.ai.chat": "Chat IA",
        "settings.title": "Paramètres",
        "settings.profile": "Profil",
        "settings.appearance": "Apparence",
        "settings.shortcuts": "Raccourcis",
        "settings.notifications": "Notifications",
        "settings.privacy": "Confidentialité",
        "settings.advanced": "Avancé",
        "settings.profile.name": "Nom complet",
        "settings.profile.email": "Adresse e-mail",
        "settings.profile.bio": "Biographie",
        "settings.profile.namePlaceholder": "Entrez votre nom",
        "settings.profile.emailPlaceholder": "Entrez votre e-mail",
        "settings.profile.bioPlaceholder": "Parlez-nous de vous",
        "settings.theme.title": "Thème",
        "settings.theme.light": "Clair",
        "settings.theme.dark": "Sombre",
        "workingPlane.toggleDynamic": "Basculer le plan de travail dynamique",
        "workingPlane.fromSection": "Créer un plan de travail à partir d'une section",
        "body.cylinder": "Cylindre",
        "body.cone": "Cône",
        "body.sphere": "Sphère",
        "body.ellipse": "Ellipse",
        "body.pyramid": "Pyramide",
        "ellipsoid.radiusX": "Rayon X (Ellipsoïde)",
        "ellipsoid.radiusY": "Rayon Y (Ellipsoïde)",
        "ellipsoid.radiusZ": "Rayon Z (Ellipsoïde)",
        "ellipse.majorRadius": "Rayon Majeur (Ellipse)",
        "ellipse.minorRadius": "Rayon Mineur (Ellipse)",
        "command.pyramid": "Pyramide",
        "command.cylinder": "Cylindre",
        "command.cone": "Cône",
        "command.sphere": "Sphère",
        "command.ellipse": "Ellipse",
        "command.chamfer": "Abraser",
        "command.copySubShape": "Copier Sous-Forme",
        "command.explode": "Exploser",
        "command.fillet": "Arrondir",
        "command.removeFeature": "Supprimer la fonctionnalité",
        "command.removeSubShapes": "Supprimer les sous-formes",
        "command.toShell": "Vers Coque",
        "command.toSolid": "Vers Solide",
        "ribbon.group.2d": "Groupe 2D",
        "ribbon.group.3d": "Groupe 3D",
        "ribbon.group.other": "Autre",
        "ribbon.tab.tools": "Outils",
        "statusBar.snap": "Snap",
        "statusBar.tracking": "Tracking",
        "chat.shapesList.currentDocument": "Formes du Document Actuel",
        "chat.shapesList.allDocuments": "Formes des Autres Documents",
        "chat.shapesList.noDocument": "Aucun document actif pour lister les formes.",
        "chat.shapesList.noStorage": "Stockage non disponible pour récupérer les documents.",
        "chat.shapesList.errorLoading": "Erreur lors du chargement de la liste des formes.",
    },
} satisfies Locale;
